import { Functions } from '@/library/utils/functions';
import trim = Functions.trim;

export default function validateParams(p) {
  const str = JSON.stringify(p);
  let res: any = {};
  res = JSON.parse(str, (key, val) => {
    if (val !== undefined && val !== null && key.indexOf('_') !== 0) {
      /*  检测是否含有全角，并转化为半角 最后调用trim方法去前后空格 */
      if (typeof val === 'string') {
        return trim(val);
      }
      return val;
    }
  });
  return res;
}
